import React, { useState } from 'react';
import { Grid, Card, CardContent, Typography, Button, CardMedia, Box, Dialog, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

// Importar imágenes
import imgBasico from '../../assets/invitacionBasico.webp';
import Doppler1 from '../../assets/notaDoppler1.webp';
import Doppler2 from '../../assets/notaDoppler2.webp';
import Doppler3 from '../../assets/notaDoppler3.webp';
import Doppler5 from '../../assets/notaDoppler5.webp';
import Doppler4 from '../../assets/notaDoppler4.mp4';

const diplomasData = [
  {
    title: 'Invitacion al Diplomado Basico',
    description: 'Iniciamos el 28 de marzo de 2025',
    image: imgBasico,
    video: '', // Si no hay video, dejar vacío
    route: '',
  },
  {
    title: 'Diplomado Doppler materno fetal y ecografía fetal',
    description: '',
    image: Doppler5,
    video: Doppler4, // Video para esta tarjeta
    route: '',
  },
  {
    title: 'Diplomado Doppler materno fetal y ecografía fetal',
    description: '',
    image: Doppler1,
    video: '', // Si no hay video, dejar vacío
    route: '',
  },
  {
    title: 'Diplomado Doppler materno fetal y ecografía fetal',
    description: '',
    image: Doppler2,
    video: '', // Si no hay video, dejar vacío
    route: '',
  },
  {
    title: 'Diplomado Doppler materno fetal y ecografía fetal',
    description: '',
    image: Doppler3,
    video: '', // Video para esta tarjeta
    route: '',
  },
];

const Diplomas = () => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleOpenMedia = (media) => {
    if (media) {
      setSelectedImage(media);  // Set the selected media (could be image or video)
      setScale(1);
      setPosition({ x: 0, y: 0 });
      setOpen(true);
    }
  };

  const handleWheel = (event) => {
    event.preventDefault();
    setScale((prevScale) => {
      const newScale = Math.max(1, Math.min(prevScale + event.deltaY * -0.01, 3));
      if (newScale === 1) {
        setPosition({ x: 0, y: 0 }); // Centrar la imagen al hacer zoom out completo
      }
      return newScale;
    });
  };

  const handleZoomIn = () => setScale((prevScale) => Math.min(prevScale + 0.2, 3));
  const handleZoomOut = () => {
    setScale((prevScale) => {
      const newScale = Math.max(prevScale - 0.2, 1);
      if (newScale === 1) {
        setPosition({ x: 0, y: 0 }); // Centrar la imagen si vuelve al zoom normal
      }
      return newScale;
    });
  };

  const handleDragStart = (event) => {
    event.preventDefault();
    const startX = event.clientX;
    const startY = event.clientY;
    const startPos = { ...position };

    const handleMouseMove = (moveEvent) => {
      setPosition({
        x: startPos.x + (moveEvent.clientX - startX),
        y: startPos.y + (moveEvent.clientY - startY),
      });
    };

    const handleMouseUp = () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <Box sx={{ mx: 4 }}>
      <Grid container spacing={4} justifyContent="center">
        {diplomasData.map((diploma, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                borderRadius: 4,
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
                transition: 'transform 0.3s, box-shadow 0.3s',
                minHeight: '450px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                background: 'linear-gradient(to bottom, #ffffff, #f9f9f9)',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.25)',
                },
                cursor: 'pointer',
              }}
              onClick={() => handleOpenMedia(diploma.video || diploma.image)} // Verifica si hay video o imagen
            >
              <Box sx={{ padding: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                {diploma.image && (
                  <CardMedia
                    component="img"
                    image={diploma.image}
                    alt={`Imagen de ${diploma.title}`}
                    sx={{
                      height: '300px',
                      width: '100%',
                      maxWidth: '500px',
                      borderRadius: '16px',
                      objectFit: 'cover',
                    }}
                  />
                )}
                <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: 3, flexGrow: 1 }}>
                  <Typography variant="h5" sx={{ fontWeight: 700, marginBottom: 2, color: '#2c3e50' }}>
                    {diploma.title}
                  </Typography>
                  <Typography variant="body1" sx={{ marginBottom: 3, color: '#e74c3c', fontWeight: 'bold' }}>
                    {diploma.description}
                  </Typography>
                  <Button
                    component={Link}
                    variant="contained"
                    sx={{
                      px: { xs: 3, md: 4 },
                      py: { xs: 1, md: 1.5 },
                      fontSize: { xs: '0.9rem', md: '1rem' },
                      fontWeight: 600,
                      color: '#fff',
                      backgroundColor: 'rgb(51, 64, 64)',
                      borderRadius: '10px',
                      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: 'rgb(41, 54, 54)',
                        transform: 'scale(1.05)',
                        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
                      },
                    }}
                    endIcon={<ArrowForwardIosIcon />}
                  >
                    Ver nota
                  </Button>
                </CardContent>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Dialog con zoom y movimiento */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xl"
        fullScreen
        sx={{
          backdropFilter: 'blur(20px)',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          '& .MuiPaper-root': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
      >
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
          }}
          onWheel={handleWheel}
        >
          {/* Botón de cerrar */}
          <IconButton onClick={() => setOpen(false)} sx={{ position: 'absolute', top: 20, right: 20, backgroundColor: '#333', color: 'white', zIndex: 3, border:'2px solid white' }}>
            <CloseIcon />
          </IconButton>

          {/* Botones de zoom */}
          <Box
            sx={{
              position: 'absolute',
              bottom: 40,
              right: 20,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              zIndex: 3,
            }}
          >
            <IconButton onClick={handleZoomIn} sx={{ backgroundColor: '#222', color: 'white', border: '2px solid white' }}>
              <AddIcon />
            </IconButton>
            <IconButton onClick={handleZoomOut} sx={{ backgroundColor: '#222', color: 'white', border: '2px solid white' }}>
              <RemoveIcon />
            </IconButton>
          </Box>

          {/* Si hay video, mostrar el reproductor; si no, mostrar la imagen */}
          {selectedImage && selectedImage.includes('mp4') ? (
            <Box sx={{ maxWidth: '85vw', maxHeight: '85vh' }}>
              <video
                src={selectedImage}
                controls
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '12px',
                  cursor: scale > 1 ? 'grab' : 'default',
                  transition: 'transform 0.2s ease-out',
                }}
              />
            </Box>
          ) : (
            <img
              src={selectedImage}
              alt="Imagen seleccionada"
              style={{
                transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
                maxWidth: '85vw',
                maxHeight: '85vh',
                borderRadius: '12px',
                cursor: scale > 1 ? 'grab' : 'default',
                transition: 'transform 0.2s ease-out',
                zIndex: 2,
              }}
              onMouseDown={scale > 1 ? handleDragStart : null}
            />
          )}
        </Box>
      </Dialog>
    </Box>
  );
};

export default Diplomas;